// Schweizer Kantone als Regionen für die Quellen-Registry.
// Gespeichert wird das Kürzel (z.B. "ZH"); "CH" steht für national/überregionale
// Quellen, die keinem einzelnen Kanton zugeordnet werden können.
// Muss mit dem Backend übereinstimmen: backend/app/utils/regions.py

export const SWISS_REGIONS = [
  { code: 'ZH', label: 'Zürich' },
  { code: 'BE', label: 'Bern' },
  { code: 'LU', label: 'Luzern' },
  { code: 'UR', label: 'Uri' },
  { code: 'SZ', label: 'Schwyz' },
  { code: 'OW', label: 'Obwalden' },
  { code: 'NW', label: 'Nidwalden' },
  { code: 'GL', label: 'Glarus' },
  { code: 'ZG', label: 'Zug' },
  { code: 'FR', label: 'Freiburg' },
  { code: 'SO', label: 'Solothurn' },
  { code: 'BS', label: 'Basel-Stadt' },
  { code: 'BL', label: 'Basel-Landschaft' },
  { code: 'SH', label: 'Schaffhausen' },
  { code: 'AR', label: 'Appenzell A. Rh.' },
  { code: 'AI', label: 'Appenzell I. Rh.' },
  { code: 'SG', label: 'St. Gallen' },
  { code: 'GR', label: 'Graubünden' },
  { code: 'AG', label: 'Aargau' },
  { code: 'TG', label: 'Thurgau' },
  { code: 'TI', label: 'Tessin' },
  { code: 'VD', label: 'Waadt' },
  { code: 'VS', label: 'Wallis' },
  { code: 'NE', label: 'Neuenburg' },
  { code: 'GE', label: 'Genf' },
  { code: 'JU', label: 'Jura' },
  { code: 'CH', label: 'Schweiz (überregional)' },
];

export const REGION_LABELS = SWISS_REGIONS.reduce((acc, r) => {
  acc[r.code] = r.label;
  return acc;
}, {});

// Typ der Quelle
export const SOURCE_TYPES = [
  { value: 'aggregator', label: 'Aggregator' }, // Eventfrog, Guidle, kikuka …
  { value: 'association', label: 'Verein' },
  { value: 'tourism', label: 'Tourismus-Portal' },
  { value: 'museum', label: 'Museum' },
  { value: 'theater', label: 'Theater' },
  { value: 'community', label: 'Gemeinde' },
  { value: 'library', label: 'Bibliothek' },
  { value: 'company', label: 'Unternehmen' },
  { value: 'other', label: 'Andere' },
];

export const SOURCE_TYPE_LABELS = SOURCE_TYPES.reduce((acc, t) => {
  acc[t.value] = t.label;
  return acc;
}, {});

// Status der Nutzungs-/Scraping-Erlaubnis (inkl. Badge-Farbe)
export const PERMISSION_STATUSES = [
  { value: 'granted', label: 'Erteilt', badgeClass: 'bg-green-100 text-green-800' },
  { value: 'pending', label: 'Angefragt', badgeClass: 'bg-yellow-100 text-yellow-800' },
  { value: 'not_required', label: 'Nicht nötig', badgeClass: 'bg-blue-100 text-blue-800' },
  { value: 'unclear', label: 'Unklar', badgeClass: 'bg-gray-100 text-gray-800' },
];

export const PERMISSION_STATUS_MAP = PERMISSION_STATUSES.reduce((acc, s) => {
  acc[s.value] = s;
  return acc;
}, {});
